/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { factoryT, fields } from 'factory-t';
import {
    CashRegisterModelDto,
    CASH_REGISTER_MODEL_STATUS,
    CashRegisterModelDetailsDto,
    StatusHistoryDto,
    FactoryNumberDto,
    CheckSumDto,
    VersionDto,
    VersionStatus,
    ModelDocumentDto,
    PresignedFileInfo,
    SoftwareVersionItemDto,
} from './cashRegistersClient.typings';

export const cashRegisterDtoFactory = factoryT<CashRegisterModelDto>({
    taxNumber: (ctx) => `000${ctx.index}`,
    name: (ctx) => `Model 2019_#${ctx.index}`,
    status: fields.sequence([...CASH_REGISTER_MODEL_STATUS]),
    operatorTaxNumber: (ctx) => `02000007${ctx.index}`,
    count: 21,
    registrationDateAtUtc: '2020-02-02T11:27:11.996063',
    attestationDateAtUtc: '2020-02-02T11:27:11.996063',
    activationDateAtUtc: '2020-02-02T11:27:11.996063',
    reattestationDateAtUtc: null,
    eliminationDateAtUtc: null,
    agent: fields.sequence([true, false, null, false, true]),
    portable: fields.sequence([true, false, null, false, true]),
});

const statusHistoryItemFactory = factoryT<StatusHistoryDto>({
    status: fields.sequence([...CASH_REGISTER_MODEL_STATUS]),
    statusDateAtUtc: '2020-02-02T11:27:11.996063',
    userName: 'Ivan Petrovich',
    comment:
        'Please registrate my cash register Please registrate my cash register Please registrate my cash register Please registrate my cash register Please registrate my cash register',
    active: fields.sequence([false, true, false, false, false]),
});

const CASH_REGISTERS_NAMES = ['Mercury - 1', 'Sharp - 29', 'Siemens - 21-1'] as const;

export const modelDocumentDtoFactory = factoryT<ModelDocumentDto>({
    id: (ctx) => `55000${ctx.index}`,
    name: (ctx) => `Document_${100 + ctx.index}`,
    userName: 'Ivanov Ivan Ivanovich',
    userId: (ctx) => `100${ctx.index}`,
    insertedAtUtc: fields.sequence([
        '2020-01-25T11:27:11.996063',
        '2020-02-11T11:27:11.996063',
        '2020-03-02T11:27:11.996063',
    ]),
    versionName: (ctx) => `1.01.0${ctx.index}`,
    versionId: (ctx) => `2000${ctx.index}`,
});

export const cashRegistersDetailsDtoFactory = factoryT<CashRegisterModelDetailsDto>({
    name: fields.sequence([...CASH_REGISTERS_NAMES]),
    taxNumber: (ctx) => `000${ctx.index}`,
    operatorTaxNumber: (ctx) => `00019${ctx.index + 20}`,
    operatorName: 'CASPOS MƏHDUD MƏSULİYYƏTLİ CƏMİYYƏTİ',
    softName: 'Super soft',
    hardwareName: 'IBM 9000',
    activities: ['RETAIL', 'ADVERTISING', 'BANK', 'BEAUTY', 'CAFE', 'CAR_SERVICE'],
    cashRegistersCount: 21,
    statusHistory: statusHistoryItemFactory.list({ count: 5 }),
    attestationKey: '98712349#9-861',
    attestationHost: 'fiscal.noogadev.com',
    attestationPort: 443,
    agent: false,
    portable: true,
});

export const cashRegistersFactoryNumbersListDto = factoryT<FactoryNumberDto>({
    factoryNumber: (ctx) => `13214509485${ctx.index}`,
    registrationDate: '2020-02-02T11:27:11.996063',
    cashBoxTaxNumber: fields.sequence(['', '323476', '6788_8']),
});

export const softwareVersionDataFactory = factoryT<SoftwareVersionItemDto>({
    id: (ctx) => 3000 + ctx.index,
    name: (ctx) => `1.1.${ctx.index}`,
    status: fields.sequence([
        VersionStatus.ACTIVE,
        VersionStatus.ACTIVE,
        VersionStatus.ACTIVE,
        VersionStatus.UNKNOWN,
        VersionStatus.OUTDATED,
        VersionStatus.OUTDATED,
        VersionStatus.ACTIVE,
        VersionStatus.UNKNOWN,
    ]),
    statusDateAtUtc: '2023-07-08T15:19:42.097694',
});

export const checkSumDtoFactory = factoryT<CheckSumDto>({
    checksum: (ctx) =>
        `${ctx.index}bc4221458d3eda7b2b0bdcc753578a4c3c743e18997b0bfa6769210bc5cd6e3af216f37ad3434e38014168c32690375ff5a470d63128f623978b608183aa4979`,
    fiscalDriverVersion: (ctx) => `3.${ctx.index}.0`,
    firmwareVersion: (ctx) => `1.23.${ctx.index}`,
    insertedDateAtUtc: '2022-07-08T15:19:42.097694',
});

export const versionDtoFactory = factoryT<VersionDto>({
    id: (ctx) => `3000${ctx.index}`,
    name: (ctx) => `1.03.${ctx.index}`,
    status: fields.sequence([
        VersionStatus.ATTESTATION,
        VersionStatus.ACTIVE,
        VersionStatus.ACTIVE,
        VersionStatus.ACTIVE,
        VersionStatus.ACTIVE,
        VersionStatus.ACTIVE,
        VersionStatus.ACTIVE,
        VersionStatus.OUTDATED,
        VersionStatus.OUTDATED,
        VersionStatus.ELIMINATED,
        VersionStatus.ELIMINATED,
    ]),
    statusDateAtUtc: '2023-07-08T15:19:42.097694',
    fiscalDriverVersion: (ctx) => `3.${ctx.index}.0`,
    firmwareVersion: (ctx) => `1.23.${ctx.index}`,
    checksum: (ctx) =>
        `${ctx.index}bc4221458d3eda7b2b0bdcc753578a4c3c743e18997b0bfa6769210bc5cd6e3af216f37ad3434e38014168c32690375ff5a470d63128f623978b608183aa4979`,
});

export const presignedFileInfoDtoFactory = factoryT<PresignedFileInfo>({
    id: (ctx) => `13214509485${ctx.index}`,
    name: (ctx) => `someFileName${ctx.index}.doc`,
    userId: (ctx) => `123${ctx.index}`,
    presignedPutObjectUrl: 'http://someUrl/',
});
